import { useCallback } from "react";

import { useTranslations } from "lib/i18n";

/**
 * Category names arrive from the API already rendered in English, so they cannot
 * be translated at the source from here. They do arrive with `urlSlug`, which is
 * part of the public URL contract (/community/categories/approved) and therefore
 * cannot change server-side without breaking links -- a safe key to map on. The
 * display name is not: rewording it server-side would silently break the
 * mapping.
 *
 * Unrecognised slugs fall through to the API's own name, so a category added
 * server-side shows up in English rather than breaking. That fallback is also
 * the migration path: once the API serves localized names, deleting the
 * `categories` messages hands rendering back to the server with no code change.
 */
export function useCategoryLabel() {
  const t = useTranslations("community");

  return useCallback(
    (category: { urlSlug: string; name: string }) =>
      t.optional(`categories.${category.urlSlug}`) ?? category.name,
    [t],
  );
}
